import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { mergeJsonQueryAction } from '../../../../actions/jsonQuery';
import { addTag } from '../../../../actions/tags';
import { SearchModalSuggestions, SearchModalSuggestionCard } from '../../../../components/SearchModal';
import { selectSuggestions } from '../../../../selectors/searchModal';
import { ISuggestionItem } from '../../../../types/suggestions';
import { mapSuggestToTag } from '../../../../utils/tags';

export interface ISearchModalSuggestionsContainer {
  onClick?: () => void;
}

export const SearchModalSuggestionsContainer: React.FC<ISearchModalSuggestionsContainer> = ({ onClick }) => {
  const suggestions = useSelector(selectSuggestions);
  const dispatch = useDispatch();

  const handleSuggestionClick = React.useCallback(
    (suggestion: ISuggestionItem) => {
      const { jsonQuery } = suggestion;

      dispatch(addTag(mapSuggestToTag(suggestion)));
      dispatch(mergeJsonQueryAction(jsonQuery));

      if (onClick) {
        onClick();
      }
    },
    [onClick],
  );

  if (!suggestions) {
    return null;
  }

  return (
    <SearchModalSuggestions>
      {suggestions.map(suggestion => (
        <SearchModalSuggestionCard
          onClick={handleSuggestionClick}
          suggestion={suggestion}
          key={`${suggestion.title}/${suggestion.id}`}
        />
      ))}
    </SearchModalSuggestions>
  );
};
